import { cardsItems } from '@/mocks/homeMangaData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">推荐漫画</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            编辑精选的高分完结漫画，每一部都值得从头刷到尾
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48 md:h-52">
                <img
                  src={item.image}
                  alt={`${item.title} - ${item.subtitle}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="500"
                  height="350"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    (t.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 right-3">
                  <span className={`px-2.5 py-0.5 ${item.tagColor} text-background-50 rounded-full text-xs font-semibold`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  {item.stats.map((stat, i) => (
                    <span key={i} className="flex items-center gap-1">
                      {i === 0 && <i className="ri-book-open-line text-primary-400"></i>}
                      {i === 1 && <i className="ri-star-fill text-accent-400"></i>}
                      {i === 2 && <i className="ri-eye-line text-secondary-400"></i>}
                      {stat}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <button className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
            浏览全部漫画 <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}